import { array, intersect, nullable, partial, string, struct } from 'io-ts/Decoder';

import { Id as Tag } from '../../../file/tag/Id';
import { Id as FolderId } from '../../../folder/Id';

export const RequestItem = intersect(
	struct({
		frontendFileId: string,
		filename: string,
		tags: array(Tag),
	})
)(
	partial({
		label: string,
		versionId: string,
		parentFolderId: nullable(FolderId),
	})
);
